<template>
  <div>
    <loader :data="blocks">
      <div v-for="block in blocks" :key="block.id" class="row-mobile">
        <div class="list-row-border-b">
          <div>{{ $t("ID") }}</div>
          <link-block :id="block.id"></link-block>
        </div>

        <div class="list-row-border-b">
          <div>{{ $t("Height") }}</div>
          <div>{{ block.height }}</div>
        </div>

        <div class="list-row-border-b">
          <div>{{ $t("Timestamp") }}</div>
          <div>{{ readableTimestamp(block.timestamp) }}</div>
        </div>

        <div class="list-row-border-b">
          <div>{{ $t("Transactions") }}</div>
          <div>{{ block.numberOfTransactions }}</div>
        </div>

        <div class="list-row-border-b">
          <div>{{ $t("Generated by") }}</div>
          <link-wallet :public-key="block.generatorPublicKey"></link-wallet>
        </div>

        <div class="list-row-border-b">
          <div>{{ $t("Amount (token)", {token: networkToken()}) }}</div>
          <div>{{ readableCrypto(block.totalForged) }}</div>
        </div>

        <div class="list-row">
          <div>{{ $t("Fee (token)", {token: networkToken()}) }}</div>
          <div>{{ readableCrypto(block.totalFee) }}</div>
        </div>
      </div>
    </loader>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    blocks: {
      type: Array,
      required: true,
    }
  }
}
</script>

<style scoped>
.row-mobile:nth-child(even) {
  background-color: var(--color-theme-table-row);
}
</style>



// WEBPACK FOOTER //
// src/components/tables/mobile/Blocks.vue